import { motion } from 'framer-motion';
import styled from 'styled-components';

import theme from 'styles/theme';

export const TimerContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  margin-bottom: 4px;
`;

export const Coin = styled.div<{ drawerOpen?: boolean; pixelsDrawer: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.COLORS.RED_1};
  border-radius: 50%;
  width: 24px;
  height: 24px;
  margin: 0 0 4px auto;
  z-index: 9999;

  transform: ${props =>
    props.drawerOpen ? `translateX(-${props.pixelsDrawer})` : `translateX(${props.pixelsDrawer})`};
`;

export const Timer = styled.div<{
  drawerOpen?: boolean;
  pixelsDrawer: string;
}>`
  z-index: 9999;
  transform: ${props =>
    props.drawerOpen ? `translateX(-${props.pixelsDrawer})` : `translateX(${props.pixelsDrawer})`};
`;

export const CoinContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  margin-bottom: 4px;
`;

export const MenuContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 100%;
  transform: translateX(70px);
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
`;

export const MenuItem = styled(motion.div)``;

export const FilterButtonCopilot = styled.button<{
  drawerOpen: boolean;
  disabled?: boolean;
  pixelsDrawer: string;
  isForward?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${theme.COLORS.BACKGROUND_SECONDARY};
  border-color: transparent;
  height: 67px;
  width: 67px;
  border-radius: 50%;
  margin-bottom: 0.5rem;
  align-self: center;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.75);
  transition: transform 0.3s ease;

  .z-index {
    z-index: 1000;
  }

  transform: ${props =>
    props.drawerOpen ? `translateX(-${props.pixelsDrawer})` : `translateX(${props.pixelsDrawer})`};

  transform: ${props => (props.isForward ? 'translateX(-45px)' : '')};

  svg {
    width: 28px;
    margin-right: 0px;
  }

  &:disabled {
    cursor: default;
    background-color: ${theme.COLORS.BACKGROUND_SECONDARY};
    &:hover {
      background-color: ${theme.COLORS.BACKGROUND_SECONDARY};
    }
  }

  &:hover {
    transform: ${props =>
      props.drawerOpen
        ? `translateX(-${props.pixelsDrawer}) scale(1.05)`
        : `translateX(${props.pixelsDrawer}) scale(1.05)`};
  }
`;

export const FilterButtonCopilotCenter = styled.button<{
  drawerOpen: boolean;
  disabled?: boolean;
  pixelsDrawer: string;
  isForward?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${theme.COLORS.BACKGROUND_SECONDARY};
  border-color: transparent;
  height: 67px;
  width: 67px;
  border-radius: 50%;
  margin-bottom: 0.5rem;
  align-self: center;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.75);
  transition: transform 0.3s ease;
  transform: translateX(-45px);

  z-index: 1000000000000;

  svg {
    width: 28px;
    margin-right: 0px;
  }

  &:hover {
    transform: translateX(-45px) scale(1.05);
  }
`;

export const FilterButton = styled.button<{
  drawerOpen?: boolean;
  pixelsDrawer: string;
}>`
  display: flex;
  align-items: end;
  justify-content: center;
  flex-direction: column;
  background-color: ${theme.COLORS.BACKGROUND_SECONDARY};
  border-color: transparent;
  height: 67px;
  width: 61px;
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
  margin-bottom: 0.5rem;
  align-self: flex-end;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.75);
  transition: transform 0.3s ease;
  z-index: 9999;

  .z-index {
    z-index: 9999;
  }

  transform: ${props =>
    props.drawerOpen ? `translateX(-${props.pixelsDrawer})` : `translateX(${props.pixelsDrawer})`};

  svg {
    margin-right: 6px;
  }

  &:hover {
    transform: ${props =>
      props.drawerOpen
        ? `translateX(-${props.pixelsDrawer}) scale(1.05)`
        : `translateX(${props.pixelsDrawer}) scale(1.05)`};
  }
`;

export const FilterTitle = styled.span`
  color: ${theme.COLORS.WHITE_3};
  text-align: end;
  margin-right: 6px;
  font-family: Roboto;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 0.75rem;
  margin-left: 6px;
  margin-top: 1px;
`;

export const FilterTitleCopilot = styled.span<{ disabled?: boolean }>`
  color: ${props => (props.disabled ? 'gray' : `${theme.COLORS.TEXT_PRIMARY}`)};
  text-align: center;
  margin-right: 6px;
  font-family: Roboto;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 0.75rem;
  margin-left: 6px;
  margin-top: 1px;
  margin-bottom: 8px;
`;

export const DrawerMain = styled.div`
  position: fixed;
  top: 5rem;
  width: 100px;
  height: 100vh;
  background-color: ${theme.COLORS.BACKGROUND_SECONDARY};
  z-index: 1000;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
`;

export const DrawerContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1006;
  right: 0;
`;

export const SidebarContainer = styled.div`
  background: ${theme.COLORS.BACKGROUND_SECONDARY};
  flex: 1;
  height: 100%;
  overflow-y: scroll;
  padding: 0 0px 72px 0px;
`;

export const Sidebar = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const SidebarButton = styled.button<{
  active?: boolean;
  disabled?: boolean;
  menuHidden?: boolean;
}>`
  box-sizing: border-box;
  height: 80px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${props =>
    props.active ? `${theme.COLORS.BACKGROUND_PRIMARY}` : `${theme.COLORS.BACKGROUND_SECONDARY}`};
  opacity: ${props => (props.active ? '1' : '0.7')};
  border: none;
  border-left: ${props => (props.active ? `4px solid ${theme.COLORS.PRIMARY}` : 'none')};

  span {
    font-weight: ${props => (props.active ? '700' : '400')};
  }

  &:hover {
    opacity: 1;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }
`;

export const SidebarButtonCopilot = styled.button<{ active?: boolean }>`
  box-sizing: border-box;
  height: 80px;
  width: 100%;
  padding: 0 16px 0 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${props => (props.active ? '#0A0A0A' : '#161717')};
  border: none;
  border-left: ${props => (props.active ? `4px solid ${theme.COLORS.PRIMARY}` : 'none')};

  span {
    font-weight: ${props => (props.active ? '700' : '400')};
  }

  &:hover {
    // opacity: 1;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }
`;

export const ButtonTitle = styled.span`
  color: #e9e9f0;
  text-align: center;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  line-height: 12px;
  margin-top: 3px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const ContentFilter = styled.div<{ isCopilot?: boolean }>`
  min-width: ${props => (props.isCopilot ? '378px' : '286px')};
  background: ${theme.COLORS.BACKGROUND_PRIMARY};
  //position: absolute;
  transform: translateX(-100%);
  padding: 8px;
  z-index: 1005;
  top: 0;
  bottom: 0;
`;

export const HeaderMenuAdvisor = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${theme.COLORS.BACKGROUND_SECONDARY};
  color: ${theme.COLORS.PRIMARY};
  padding: 12px 12px 12px 0;
  font-size: 12px;
  gap: 4px;

  svg {
    width: '1rem';
    color: ${theme.COLORS.PRIMARY};
  }

  img {
    width: '1rem';
    color: ${theme.COLORS.PRIMARY};
  }
`;

export const ContentAdvisor = styled.div`
  min-width: 460px;
  background: ${theme.COLORS.BACKGROUND_SECONDARY};
  position: absolute;
  transform: translateX(-100%);
  padding: 8px;
  z-index: 1005;
  top: 0;
  bottom: 0;
`;

export const BoxContent = styled(motion.div)`
  width: 99%;
  height: 100vh;
  overflow: scroll;
  padding: 4px;
`;

export const BoxInternalContent = styled(motion.div)<{
  isHistoric: boolean;
  isFooter: boolean;
}>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  max-width: 350px;
  overflow-y: auto;
  padding: 4px;
  border: 1px solid;
  margin-top: 8px;
  gap: 16px;
  height: ${props => (props.isHistoric ? '86vh' : '80vh')};

  transition: transform 0.3s ease-out;

  position: ${props => (props.isFooter ? 'fixed' : 'relative')};
  bottom: ${props => (props.isFooter ? '0' : 'auto')};
  left: ${props => (props.isFooter ? '0' : 'auto')};
  width: ${props => (props.isFooter ? '100%' : 'auto')};
  z-index: ${props => (props.isFooter ? '1000' : '1')};
`;

export const HeaderInternalContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderButtonsContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const BoxChat = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 100%;
  padding: 10px;
`;

export const BoxButton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const BoxInput = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
  margin-bottom: 8px;
`;

export const TitleInternalContent = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  text-align: left;
`;

export const Heading = styled.h3`
  font-family: 'Roboto';
  color: ${theme.COLORS.PRIMARY};
  text-align: start;
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 16px;
  font-weight: 700;
  flex-direction: column;
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 48px;
  margin: 16px;
`;

export const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const FilterButtonCopilotStyled = styled(FilterButtonCopilot)`
  &:disabled {
    cursor: not-allowed;
    color: ${theme.COLORS.GRAY_10};
    &:hover {
      background-color: ${theme.COLORS.GRAY_10};
    }
  }
`;
